/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *           _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { Component, Inject, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogRef } from 'src/aero/aero-dialog/types';
import { TranslationService } from 'src/common/translation.service';
import { AssignmentHttpService } from '../assignment-http.service';
// eslint-disable-next-line import/no-cycle
import { AssignmentService } from '../assignment.service';

/**
 * Component for assignment modals.
 */
@Component({
  selector: 'bulb-assign-page-dialog',
  templateUrl: './assign-page-dialog.component.html',
  styleUrls: ['./assign-page-dialog.component.scss'],
  standalone: false,
})
export class AssignPageDialogComponent implements OnInit {

  /**
   *  It is the folder id.
   */
  assignmentId: string;

  /**
   *  Assignment object which contains groups and folders.
   */
  assignPageList: any;

  /**
   *  Boolean to show state of primary button.
   */
  primaryDisabled: boolean = true;

  /**
   *  Contains new assignment title.
   */
  collectionTitle: string;

  /**
   *  Boolean to show collection title modal.
   */
  showCollectionTitle: boolean = false;

  /**
   *  Contains the name of modal which should be visible.
   */
  modelName: string;

  /**
   * Contains Id of current group selected.
   */
  groupId: string;

  /**
   *  contains the list of non Bulb+ accounts.
   */
  ineligibleAccounts: any;

  /**
   *  create new assignment collection.
   */
  createNewAssignment: string;

  /**
   * Default Constructor
   * @param http our assignment http service.
   * @param assignmentService Our assignment service.
   * @param dynamicConfig It contains dynamic data which is passed in modal.
   * @param $translate translation service
   * @param BulbPageService Our bulb page service.
   * @param dialogRef Contains configuration reference of modal.
   */
  constructor(
    private http: AssignmentHttpService,
    private assignmentService: AssignmentService,
    private dynamicConfig : DynamicDialogConfig,
    private $translate: TranslationService,
    @Inject('BulbPageService') private BulbPageService: any,
    @Inject('DialogRef') private dialogRef:DialogRef,
  ) { }

  ngOnInit(): void {
    this.createNewAssignment = this.$translate.translateInstant('assignment_new');
    this.modelName = this.dynamicConfig.data?.modelName;
    this.ineligibleAccounts = this.dynamicConfig.data?.ineligibleAccounts;
    this.assignPageList = this.dynamicConfig.data?.assignPageList;
  }

  /**
   * show new assignment modal or make current assignment button active.
   * @param evt contains event of radio button.
   * @param group current group selected.
   */
  updatePrimary(evt, group): void {
    this.groupId = group.groupId;
    this.assignmentService.groupId = group.groupId;
    this.assignmentService.folderId = this.assignmentId;
    this.dialogRef.setPrimaryDisabled(!this.primaryDisabled);
    if (this.assignmentId === '') {
      this.showCollectionTitle = true;
      this.collectionTitle = this.BulbPageService.page.unit ? this.BulbPageService.page.unit.name
        : this.BulbPageService.compositeUnit.unit.name;
      this.assignmentService.folderName = this.collectionTitle;
    }
  }

  /**
   * Gets called when input value changes.
   * @param event change eventon input.
   */
  change(event) {
    this.dialogRef.setPrimaryDisabled(this.collectionTitle === '');
    this.assignmentService.folderName = this.collectionTitle;
  }
}
